import BLayer from './packages/BLayer'

BLayer.install = function(Vue) {
  Vue.component(BLayer.name, BLayer)
}

export default BLayer
